import { createContext } from 'react'

const CookiesContext = createContext()

export default CookiesContext
